import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { TokenService } from "./guard.service";

export const maintainanceGuard: CanActivateFn = () => {
  return inject(TokenService).canActivateMaintainance();
};
